import { apiUrl } from '../config';
import { readApiJson } from '../utils/apiResponse';

let countriesCache = null;

export async function fetchCountries({ signupOnly = false } = {}) {
  if (!signupOnly && countriesCache) return countriesCache;
  const qs = signupOnly ? '?signupOnly=1' : '';
  const res = await fetch(apiUrl(`/api/geo/countries${qs}`));
  if (!res.ok) {
    throw new Error('No se pudieron cargar los países');
  }
  const data = await readApiJson(res);
  const countries = Array.isArray(data?.countries) ? data.countries : [];
  if (!signupOnly) countriesCache = countries;
  return countries;
}

export async function fetchSubdivisions(country) {
  if (!country) {
    return { countryCode: '', countryName: '', subdivisions: [] };
  }
  const params = new URLSearchParams({ country: String(country) });
  const res = await fetch(apiUrl(`/api/geo/subdivisions?${params}`));
  if (!res.ok) {
    const err = await readApiJson(res).catch(() => ({}));
    throw new Error(err.message || 'No se pudieron cargar provincias/estados');
  }
  return readApiJson(res);
}

export function findCountryByName(countryList, name) {
  const n = String(name || '').trim().toLowerCase();
  if (!n || !Array.isArray(countryList)) return null;
  return countryList.find((c) => c.name.toLowerCase() === n || c.code.toLowerCase() === n) || null;
}
